<template>
  <div>
    <h1 class="page-header">
      {{ $t('addministration.position_feature.position') }}
    </h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              @success_update="edit_data = ''"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper class="d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('addministration.position_feature.search')"
              style="width: 300px;"
              class="kh-font"
            />
          </ts-card-wrapper>
          <ts-table :columns="columns" :records="resources" :loading="loading">
            <template slot-scope="{ record }">
              <td class="kh-font">{{ record.pos_name_kh }}</td>
              <td>{{ record.pos_name_en }}</td>
              <td>
                {{ $store.getters.limitStringShow(record.pos_description, 40) }}
              </td>
              <td class="text-center">
                <a
                  href="#"
                  v-tooltip="$t('addministration.position_feature.edit')"
                  class="text-primary mr-3"
                  @click="edit(record)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  href="#"
                  v-tooltip="$t('addministration.position_feature.delete')"
                  class="text-danger"
                  @click="destroy(record.position_id)"
                >
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'position',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      columns: [
        {
          name: this.$t('addministration.position_feature.name_kh'),
          style: 'width: 25%;'
        },
        {
          name: this.$t('addministration.position_feature.name_en'),
          style: 'width: 25%;'
        },
        { name: this.$t('addministration.position_feature.description') },
        {
          name: this.$t('addministration.position_feature.action'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('position', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.position.search
      },
      set(newVal) {
        this.$store.commit('position/SET_SEARCH', newVal)
        this.$store.commit('position/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('position/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.edit_data = data
      this.$router.push(`/positions/${data.position_id}`)
    },

    async destroy(id) {
      if (
        await this.$confirmModal.danger(
          this.$t('addministration.position_feature.are_you_sure_to_delete')
        )
      ) {
        this.$store
          .dispatch('position/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
